export const LOGO_DARK = "https://customer-assets-lxgj4vgw.emergentagent.net/job_surfaces-elite/artifacts/vhty47o9_classy%20logo.png"; // black monogram on transparent/white
export const LOGO_BLUE = "https://customer-assets-lxgj4vgw.emergentagent.net/job_surfaces-elite/artifacts/nk3xrhqk_with%20bg%20classy%20logo.png"; // white monogram on royal blue

export const IMAGES = {
  flooring: "https://images.pexels.com/photos/6877602/pexels-photo-6877602.jpeg",
  ceiling: "https://images.unsplash.com/photo-1600508772927-723e3ba305c5",
  facade: "https://images.unsplash.com/photo-1559354485-4c3b09e7dc97",
  woodTexture: "https://images.pexels.com/photos/11262212/pexels-photo-11262212.jpeg",
};

export const NAV = [
  { label: "Verticals", href: "#verticals" },
  { label: "Flooring", href: "#flooring" },
  { label: "Manifesto", href: "#manifesto" },
  { label: "Facade", href: "#facade" },
  { label: "FAQ", href: "#faq" },
  { label: "Contact", href: "#contact" },
];

export const VERTICALS = [
  {
    no: "01",
    title: "Flooring",
    desc: "Laminate, engineered, solid wood, bamboo, deck, vinyl, sports and carpets — sourced from the finest mills on earth.",
    image: IMAGES.flooring,
  },
  {
    no: "02",
    title: "Ceiling",
    desc: "Acoustic grid systems, metal waffle and architectural ceilings engineered for silence, light and geometry.",
    image: IMAGES.ceiling,
  },
  {
    no: "03",
    title: "Facade",
    desc: "Our signature terracotta facades — timeless, breathing skins that give buildings their character.",
    image: IMAGES.facade,
  },
];

export const PRODUCTS = [
  { name: "Solid Wood", tag: "Timeless grain", span: "lg:col-span-6 lg:row-span-2", img: "https://images.pexels.com/photos/6969831/pexels-photo-6969831.jpeg" },
  { name: "Engineered Wood", tag: "Stable & refined", span: "lg:col-span-3", img: "https://images.unsplash.com/photo-1600607687920-4e2a09cf159d" },
  { name: "Laminate Wooden Flooring", tag: "Everyday luxury", span: "lg:col-span-3", img: "https://images.unsplash.com/photo-1615529182904-14819c35db37" },
  { name: "Vinyl & LVT", tag: "Waterproof warmth", span: "lg:col-span-3", img: "https://images.pexels.com/photos/271816/pexels-photo-271816.jpeg" },
  { name: "Bamboo & Deck", tag: "Outdoor spirit", span: "lg:col-span-3", img: "/products/ipe-deck.png" },
  { name: "Sports Flooring", tag: "Performance grade", span: "lg:col-span-4", img: "/products/sports-flooring.png" },
  { name: "Carpet tiles and wall to wall Carpets", tag: "Broadloom to bespoke", span: "lg:col-span-4", img: "https://images.pexels.com/photos/6580227/pexels-photo-6580227.jpeg" },
  { name: "Acoustic & Facade", tag: "Ceilings & terracotta", span: "lg:col-span-4", img: "/products/terracotta-facade.png" },
];

export const MANIFESTO = [
  { no: "01", title: "Sourced from the best", body: "We exclusively represent the world's leading manufacturers, bringing globally benchmarked surfaces to your project." },
  { no: "02", title: "Engineered for architects", body: "Specification-ready systems, technical dossiers and samples — built for the way architects and builders actually work." },
  { no: "03", title: "Obsessed with detail", body: "From the grain of a plank to the shadow line of a facade, we are, quite simply, fascinated by floors." },
];

export const MANUFACTURERS = [
  "BerryAlloc", "Forbo", "Armstrong", "Japan Carpet Co.", "Ntgrate", "Kährs", "Haro",
  "Haima", "Allflor", "Egger", "Krono Swiss", "Rockwool International",
];
